import React, { useCallback } from 'react';
import Slider from 'react-slick';
import classnames from 'classnames';
import DependencyManager from "../../DependencyManager";
var css = {
  "boxWrapper": "oalp-6VWNK",
  "mobile": "oalp-2U4TH",
  "box": "oalp-3y-cn",
  "text": "oalp-3zu7v",
  "quotesIcon": "oalp-1aHdT",
  "authorImg": "oalp-38FsR",
  "separator": "oalp-1D2VL",
  "author": "oalp-3RMP4",
  "name": "oalp-3yPMB",
  "authorMeta": "oalp-2Jxyd",
  "dotsClass": "oalp-3sWMg",
  "cardContainer": "oalp-12iSL",
  "withArrows": "oalp-aj3I0",
  "desktop": "oalp-1YSWP"
};
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import { UNKNOWN } from "../../Constants/locations";
import { compose } from 'redux';
import { withRouter } from "../../Helpers/withRouter";
import SliderArrow from "./../../Components/Bundle/SliderArrow/SliderArrow";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import { getThematicParams } from "../../Helpers/trackingHelper";
import withConfig from "./../../ComponentDependency/withConfig";
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import { fileNames } from "../../Constants/imageUrls";
var defaultSlideCount = 2.3;
var MOBILE_SIZE = '58';
var DESKTOP_SIZE = '73';
var getSize = function getSize(platform) {
  return platform === 'mobile' ? MOBILE_SIZE : DESKTOP_SIZE;
};
var getImage = function getImage(url, platform) {
  return url.replace('$size$', getSize(platform));
};
var getImageSource = function getImageSource(image, name, platform) {
  return {
    url: getImage(image, platform),
    width: parseInt(getSize(platform), 10),
    height: parseInt(getSize(platform), 10),
    alt: name
  };
};
export var ReviewCarousel = function ReviewCarousel(_ref) {
  var data = _ref.data,
    metadata = _ref.metadata,
    ReactObserver = _ref.ReactObserver,
    track = _ref.track,
    widgetKey = _ref.widgetKey,
    locationId = _ref.locationId,
    browsingMode = _ref.browsingMode,
    origin = _ref.origin,
    config = _ref.config,
    params = _ref.params;
  var PanameraConstants = DependencyManager.getDependency('constants');
  var commonSetting = {
    dots: true,
    infinite: false,
    slidesToShow: metadata && metadata.count ? metadata.count : defaultSlideCount,
    slidesToScroll: 1,
    dotsClass: classnames(css.dotsClass, css[PanameraConstants.platform]),
    afterChange: function afterChange() {
      if (metadata && metadata.trackingInfo && metadata.trackingInfo.clickEvent && metadata.trackingInfo.clickEvent.name) {
        var trackingInfo = TrackingInfoManager.getTrackingInfo({
          variants_shown: widgetKey,
          browsing_location_id: locationId || UNKNOWN,
          browsing_mode: browsingMode,
          origin: origin
        });
        track(metadata.trackingInfo.clickEvent.name, trackingInfo);
      }
    },
    variableWidth: true
  };
  var handleChange = useCallback(function (inView) {
    if (inView && track && metadata && metadata.trackingInfo && metadata.trackingInfo.impressionEvent && metadata.trackingInfo.impressionEvent.name) {
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        variants_shown: widgetKey,
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin
      });
      track(metadata.trackingInfo.impressionEvent.name, Object.assign(Object.assign({}, trackingInfo), getThematicParams(params, config === null || config === void 0 ? void 0 : config.get())));
    }
  }, [browsingMode, locationId, origin, track, widgetKey, metadata, config, params]);
  var settings_desktop = Object.assign(Object.assign({}, commonSetting), {
    nextArrow: /*#__PURE__*/React.createElement(SliderArrow, {
      iconName: "arrowRightCircle",
      size: 20
    }),
    prevArrow: /*#__PURE__*/React.createElement(SliderArrow, {
      iconName: "arrowRightCircle",
      size: 20
    }),
    arrows: true
  });
  var settings_mobile = Object.assign(Object.assign({}, commonSetting), {
    arrows: false
  });
  var settings = Object.assign({}, PanameraConstants.platform === 'desktop' ? settings_desktop : settings_mobile);
  if (!(data && Array.isArray(data) && data.length > 0)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "cardContainer",
    className: classnames(css[PanameraConstants.platform], css.withArrows)
  }, ReactObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: 'div',
    onChange: handleChange,
    "data-aut-id": "observer"
  }), /*#__PURE__*/React.createElement(Slider, Object.assign({}, settings), data.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.name
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(css.boxWrapper, css[PanameraConstants.platform])
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(css.box, css[PanameraConstants.platform])
    }, /*#__PURE__*/React.createElement("i", {
      className: css.quotesIcon
    }), /*#__PURE__*/React.createElement("div", {
      className: css.text
    }, item.text), /*#__PURE__*/React.createElement("div", {
      className: css.separator
    }), /*#__PURE__*/React.createElement("div", {
      className: css.author
    }, /*#__PURE__*/React.createElement(ImageWrapper, {
      image: getImageSource(item.img ? item.img : fileNames.REVIEW_AVATAR_PLACEHOLDER, item.name, PanameraConstants.platform),
      className: css.authorImg
    }), /*#__PURE__*/React.createElement("span", {
      className: css.name
    }, item.name), item.authorMeta ? /*#__PURE__*/React.createElement("span", {
      className: css.authorMeta
    }, item.authorMeta) : null))));
  })));
};
export default compose(withComponentDependency, withRouter, withConfig)(ReviewCarousel);